// Form error handling utilities

export const handleFormErrors = (errors, form) => {
  // Clear existing error messages
  clearFormErrors(form);

  if (Array.isArray(errors)) {
    errors.forEach(error => {
      if (error.field) {
        // Handle field-specific errors
        const field = form.querySelector(`[name*="${error.field}"]`);
        if (field) {
          showFieldError(field, error.message);
        }
      } else {
        // Handle general errors
        showGeneralError(form, error.message || error);
      }
    });
  } else if (typeof errors === 'string') {
    showGeneralError(form, errors);
  }
};

export const clearFormErrors = (form) => {
  // Remove existing error messages
  form.querySelectorAll('.error-message').forEach(el => el.remove());
  form.querySelectorAll('.field-error').forEach(el => {
    el.classList.remove('field-error');
  });
};

const showFieldError = (field, message) => {
  field.classList.add('field-error');
  const errorDiv = document.createElement('div');
  errorDiv.className = 'error-message text-red-500 text-sm mt-1';
  errorDiv.textContent = message;
  field.parentNode.appendChild(errorDiv);
};

const showGeneralError = (form, message) => {
  const errorDiv = document.createElement('div');
  errorDiv.className = 'error-message bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4';
  errorDiv.textContent = message;
  form.insertBefore(errorDiv, form.firstChild);
};

// Fetch wrapper with error handling
export const fetchWithErrors = async (url, options = {}) => {
  try {
    const isFormData = options.body instanceof FormData;
    const headers = {
      'X-CSRF-Token': document.querySelector('[name="csrf-token"]')?.content,
      'Accept': 'application/json',
      ...options.headers
    };

    // Only set Content-Type if we're not sending FormData
    if (!isFormData) {
      headers['Content-Type'] = 'application/json';
    }

    const response = await fetch(url, {
      ...options,
      headers
    });

    // Try to parse JSON response, fall back to text if it fails
    let data;
    const contentType = response.headers.get('content-type');
    if (contentType && contentType.includes('application/json')) {
      data = await response.json();
    } else {
      data = await response.text();
    }

    if (!response.ok) {
      throw data;
    }

    return data;
  } catch (error) {
    // Surface the most specific message available instead of always collapsing
    // to a generic string. Rails error responses come back as
    // { success: false, errors: [...] } or { error: "..." }; some paths return
    // a plain-text/HTML body (thrown as a string).
    if (error && Array.isArray(error.errors) && error.errors.length) {
      throw error.errors;
    }
    if (error && error.error) {
      throw [error.error];
    }
    if (typeof error === 'string' && error.trim()) {
      throw [error.trim()];
    }
    throw [{ message: (error && error.message) || 'Something went wrong. Please try again.' }];
  }
};
